/**
 * Maps Lawft ID records to dropdown options.
 * @param {Array} lawftIds
 * @returns {Array<{ label: string, value: string }>}
 */
export const mapLawftIdsToOptions = (lawftIds = []) =>
  lawftIds.map((lawftId) => ({
    label: lawftId?.lawft_id_name,
    value: lawftId?.lawft_id || '',
  }));

/**
 * Maps Lawft ID records to template merge field options.
 * @param {Array} lawftIds
 * @returns {Array<{ label: string, value: string, code: string }>}
 */
export const mapLawftIdsToMergeFields = (lawftIds = []) =>
  lawftIds.map((item) => ({
    label: item.lawft_id_name,
    value: `{{lawft_id_${item.lawft_id_name.toLowerCase().replace(/ /g, '_')}}}`,
    code: `lawft_id_${item.lawft_id_name.toLowerCase().replace(/ /g, '_')}`,
  }));

/**
 * Lawft IDs to exclude from insurer dropdown (used by contacts + other insurers).
 */
export const getExcludedLawftIdsForInsurer = ({ selectedLawftIdList = {}, insuranceProviders = [], currentInsurerPk = null } = {}) => {
  const contactLawftIds = Object.values(selectedLawftIdList).flat();
  const otherInsurerLawftIds = insuranceProviders
    .filter((insurer) => insurer.pk !== currentInsurerPk)
    .flatMap((insurer) => insurer.lawft_id || []);

  return [...new Set([...contactLawftIds, ...otherInsurerLawftIds].filter(Boolean))];
};

/**
 * Builds a label lookup map from Lawft ID dropdown options.
 */
export const buildLawftIdLabelCache = (options = []) =>
  options.reduce((cache, opt) => {
    if (opt?.value) {
      cache[opt.value] = opt.label || opt.lawft_id_name;
    }
    return cache;
  }, {});

/**
 * Merges new option labels into an existing cache.
 */
export const mergeLawftIdLabelCache = (prev = {}, options = []) => ({
  ...prev,
  ...buildLawftIdLabelCache(options),
});

/**
 * Resolves Lawft ID values to display labels using a cache.
 */
export const getLawftIdDisplayLabels = (ids = [], labelCache = {}) =>
  (Array.isArray(ids) ? ids : []).map((id) => labelCache[id] || id).filter(Boolean);
